import { render } from "./AktionQuiz.vue?vue&type=template&id=14caa688"
import script from "./AktionQuiz.vue?vue&type=script&lang=js"
export * from "./AktionQuiz.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__